import { render, staticRenderFns } from "./account-layout.vue?vue&type=template&id=88da8a60&scoped=true&"
import script from "./account-layout.vue?vue&type=script&lang=js&"
export * from "./account-layout.vue?vue&type=script&lang=js&"
import style0 from "./account-layout.vue?vue&type=style&index=0&id=88da8a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88da8a60",
  null
  
)

export default component.exports